window.gsap.registerPlugin(window.ScrollTrigger);

class GalleryModule extends HTMLElement {
  constructor() {
    super();

    this.scrollType = this.dataset.scrollType;
    this.clickType = this.dataset.clickType;

    if (this.scrollType === 'css' && this.clickType === 'expand') {
      this.clickNExpand();
      return;
    }

    if (this.scrollType !== 'gsap') {
      return;
    }

    this.container = this.querySelector('[container]');
    this.panels = this.querySelectorAll('[panel]');
    this.elements = gsap.utils.toArray(this.panels);
    this.maxWidth = 0;

    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.gsap();
    });
  }

  clickNExpand() {
    this.addEventListener('click', (event) => {
      if (window.innerWidth < 1024) {
        if (!this.classList.contains('expand')) {
          this.classList.add('expand');
        } else if (event.target.hasAttribute('toggle-fullscreen')) {
          this.classList.remove('expand');
        }
      }
    });
  }

  getMaxWidth = () => {
    this.maxWidth = 0;
    this.elements.forEach((section) => {
      this.maxWidth += section.offsetWidth;
    });
  };

  gsap() {
    this.getMaxWidth();
    ScrollTrigger.addEventListener('refreshInit', this.getMaxWidth);

    // Scroll
    gsap.to(this.elements, {
      x: () => `-${this.maxWidth - window.innerWidth}`,
      ease: 'none',
      scrollTrigger: {
        trigger: this.container,
        pin: true,
        scrub: 1,
        end: () => `+=${this.maxWidth}`,
        invalidateOnRefresh: true,
        toggleClass: { targets: 'body', className: 'scroll_trigger_active' },
      },
    });

    // Animate-in panels
    gsap.fromTo(
      this.panels,
      {
        opacity: 0,
        xPercent: 25,
        yPercent: 25,
      },
      {
        opacity: 1,
        xPercent: 0,
        yPercent: 0,
        stagger: 0.15,
        ease: 'expo.out',
        duration: 1.25,
        scrollTrigger: {
          trigger: this.container,
          once: true,
          start: 'top 50%',
        },
      },
    );
  }
}

customElements.define('gallery-module', GalleryModule);
